// extracted by mini-css-extract-plugin
module.exports = {"copy":"_7448"};